import { createAction } from '@reduxjs/toolkit';

import { SUBMIT_FORGOT_PASSWORD_FORM } from './actionTypes';

export const submitForgotPasswordForm = createAction(
  SUBMIT_FORGOT_PASSWORD_FORM
);
